import { render, staticRenderFns } from "./CommentsSidebar.vue?vue&type=template&id=09759c58&"
import script from "./CommentsSidebar.vue?vue&type=script&lang=ts&"
export * from "./CommentsSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports